import { cloneDeep } from "lodash";
import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { IS_DEV } from "globals/constants";
import { fetchCurrentProjectAccess } from "store/actions/userAccesses";
import { award as constants } from "store/constants";
import { actionLoaderFactory } from "store/factories/fetchable";
import { fetchAward, notifyError } from "utils";
import { dispatch } from "store/store";
import {
	prepareSingleEntityValues,
	updateEntityAdminTeamMembers,
	updateEntityOrProperty,
} from "utils/entityHelpers";

import { awardSelectors } from "../selectors";
import { api } from "services";
import { getAwardTasks } from "./tasks";
import { setFormEntityData } from "./form";


const awardFactory = actionLoaderFactory(constants, constants.SINGLE_AWARD);
const awardValuesFactory = actionLoaderFactory(constants, constants.SINGLE_AWARD_VALUES);

export const resetAward = () => dispatch({ type: constants.RESET });

export const setAwardData = awardFactory.setData;

export const getAward = (id, options = { isRefresh: false }) => {
	return awardFactory.createLoaderAction(
		() => fetchAward(id),
		[
			(response) => {
				if (isNonEmptyString(options.caseInstanceId)) {
					response.caseInstanceId = options.caseInstanceId;
				}

				awardFactory.setData({ award: response });
				setFormEntityData({editLock: response.editLock});

				fetchCurrentProjectAccess("award");
				getAwardTasks(id);
			},
			(error) => {
				let message = isNonEmptyString(error.message) ? error.message : "Something went wrong";

				notifyError(message, error)
				awardFactory.setError(message);
			},
		],
		options,
	);
};

const onSuccessGetAwardValues = response => {
	const values = prepareSingleEntityValues(response);

	awardValuesFactory.setData(values);

	return values;
};

const onErrorGetAwardValues = error => {
	const message = IS_DEV ? error.message : "Something went wrong";

	notifyError(message, error)
	awardValuesFactory.setError(message);
};

export const getAwardValues = ({ awardId, fieldKeys = [] }) => {
	const fields = isNonEmptyArray(fieldKeys) ? fieldKeys.join(",") : "";

	return awardValuesFactory.createLoaderAction(
		() => api.awards.getValues(awardId, { fields }),
		[
			onSuccessGetAwardValues,
			onErrorGetAwardValues,
		],
	);
};

export const updateAwardAdminTeamMembers = idAdminTeamMemberArray => {
	const award = updateEntityAdminTeamMembers(idAdminTeamMemberArray, cloneDeep(awardSelectors.award()));

	awardFactory.setData({ award });
};

export const updateAwardOrProperty = (value, property = '') => {
	const award = updateEntityOrProperty(awardSelectors.award())(value, property);

	awardFactory.setData({ award });

	return award;
};

const onErrorRefresh = error => {
	notifyError(error.message, error);
	awardFactory.setError(error.message);
};

export const refreshReviewEvents = id => {
	if (isNonEmptyString(id)) {
		return awardFactory.createLoaderAction(
			() => api.awards.get(id),
			[
				response => {
					updateAwardOrProperty(response?.reviewEvents, "reviewEvents");
					updateAwardOrProperty(response?.certificationEvents, "certificationEvents");
					updateAwardOrProperty(response?.formRules, "formRules");
					updateAwardOrProperty(response?.round, "round");
				},
				onErrorRefresh,
			],
			{ isRefresh: true },
		);
	}
};
